import { render, staticRenderFns } from "./YabbrBrochure.vue?vue&type=template&id=3701e2aa"
import script from "./YabbrBrochure.vue?vue&type=script&lang=js"
export * from "./YabbrBrochure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports